<template>
    <div>
        <div class="x-stat">
            <a-row>
                <a-col :span="3">
                    <a-statistic title="数量" :value="totalRow" />
                </a-col>
            </a-row>
        </div>

        <a-card :bordered="false">
            <div class="x-filter">
                <a-form layout="inline">
                    <a-row :gutter="24">
                        <a-col :span="4">
                            <a-form-item label="帮助名称">
                                <a-input v-model="queryParams.name" placeholder="请输入帮助名称"/>
                            </a-form-item>
                        </a-col>
                        <a-col :span="4">
                            <a-form-item label="标题">
                                <a-input v-model="queryParams.title" placeholder="请输入标题"/>
                            </a-form-item>
                        </a-col>
                        <template v-if="advanced">
                            <a-col :md="8">
                                <a-form-item label="创建时间">
                                    <a-range-picker @change="onCreateTime" v-model="createTime" style="width:100%" />
                                </a-form-item>
                            </a-col>
                        </template>
                        <a-col :span="!advanced && 4 || 24">
                            <span class="x-filter-submit-box" :style="advanced && {float:'right', overflow:'hidden'} || {}">
                                <a-button type="primary" @click="fetchTableData">查询</a-button>
                                <a-button style="margin-left:8px" @click="resetQuery">重置</a-button>
                                <a @click="toggleAdvanced" style="margin-left: 8px">
                                    {{ advanced ? '收起' : '展开' }}
                                    <a-icon :type="advanced ? 'up' : 'down'"/>
                                </a>
                            </span>
                        </a-col>
                    </a-row>
                </a-form>
            </div>

            <div class="x-tool">
                <a-button type="primary" icon="plus" @click="add" v-has="'/content/helpPageAdd'">新增</a-button>
            </div>

            <a-table
                :rowKey="record => record.id"
                :columns="tableColumns"
                :loading="tableLoading"
                :dataSource="tableData"
                :pagination="false"
            >
                <template slot="action" slot-scope="record">
                    <a @click="update(record)" v-has="'/content/helpPageUpdate'">修改</a>
                    <a-divider type="vertical" />
                    <a-popconfirm
                        title="确定要删除这条记录吗？"
                        @confirm="deleteRecord(record)"
                        okText="确定"
                        cancelText="取消"
                    >
                        <a href="javascript:;" v-has="'/content/helpPageDel'" style="color: #ff4d4f;">删除</a>
                    </a-popconfirm>
                </template>
            </a-table>

            <div class="x-pagination">
                <a-pagination :pageSize="pageSize" v-model="pageIndex" :total="totalRow" @change="pageChange"
                  :hideOnSinglePage="true" show-less-items />
            </div>

            <help-page-form-modal
                ref="helpPageFormModal"
                :visible="helpPageFormModalVisible"
                :loading="helpPageFormModalLoading"
                @cancel="helpPageFormModalCancel"
                @ok="helpPageFormModalOk"
            />

        </a-card>
    </div>
</template>

<script>
import HelpPageFormModal from './HelpPageFormModal.vue';
import { helpPageList, helpPageAdd, helpPageUpdate, helpPageDelete } from "@/api/content/helpPage.js";
import moment from 'moment';

const tableColumns = [
    {
        title: '#',
        dataIndex: 'id'
    },
    {
        title: '帮助名称',
        dataIndex: 'name'
    },
    {
        title: '标题',
        dataIndex: 'title'
    },
    {
        title: '排序',
        dataIndex: 'seq'
    },
    {
        title: '创建时间',
        dataIndex: 'created'
    },
    {
        title: '操作',
        scopedSlots: { customRender: 'action' }
    }
];

export default {
    components: {
        HelpPageFormModal
    },
    data() {
        return {
            advanced: false,
            queryParams: {},
            tableLoading: false,
            tableColumns,
            tableData: [],
            totalRow: 0,
            pageSize: 20,
            pageIndex: 1,
            helpPageFormModalVisible: false,
            helpPageFormModalLoading: false,
            createTime:[]
        }
    },
    created() {
        this.fetchTableData();
    },
    methods: {
        fetchTableData() {
            this.tableLoading = true;
            this.queryParams.pageSize = this.pageSize;
            this.queryParams.page = this.pageIndex;
            return helpPageList(this.queryParams).then(res => {
                if (res && res.data) {
                    this.tableData = res.data.recordList || [];
                    this.totalRow = res.data.totalRow || 0;
                } else {
                    this.tableData = [];
                    this.totalRow = 0;
                }
                this.tableLoading = false;
            }).catch(error => {
                console.error('获取列表失败:', error);
                this.$message.error('获取列表失败，请稍后重试');
                this.tableLoading = false;
            });
        },
        toggleAdvanced() {
            this.advanced = !this.advanced;
        },
        resetQuery() {
            // 清空查询条件
            this.queryParams = {};
            // 清空创建时间选择器
            this.createTime = [];
            // 重置分页到第一页
            this.pageIndex = 1;
            // 重新获取数据
            this.fetchTableData();
        },
        pageChange(current) {
            this.pageIndex = current;
            this.fetchTableData();
        },
        add() {
            this.$refs.helpPageFormModal.initForm();
            this.helpPageFormModalVisible = true;
        },
        update(record) {
            this.helpPageFormModalVisible = true;
            // 确保数据完整，使用 $nextTick 确保弹窗打开后再设置数据
            this.$nextTick(() => {
                const modal = this.$refs.helpPageFormModal;
                const ident = modal.resolveCategoryIdent(record);
                modal.form = {
                    id: record.id || 0,
                    ident,
                    name: record.name || '',
                    title: record.title || '',
                    seq: record.seq != null && record.seq !== '' ? Number(record.seq) : 50,
                    content: record.content || ''
                };
                if (ident && !modal.form.name) {
                    modal.onCategoryChange(ident);
                }
                modal.originalTitle = record.title || '';
            });
        },
        helpPageFormModalOk() {
            this.$refs.helpPageFormModal.$refs['adminForm'].validate(valid => {
                if (valid) {
                    this.helpPageFormModalLoading = true;
                    const formData = this.$refs.helpPageFormModal.form;
                    
                    // 确保数据完整性
                    const submitData = {
                        id: formData.id || 0,
                        ident: formData.ident || '',
                        name: formData.name || '',
                        title: formData.title || '',
                        seq: formData.seq != null && formData.seq !== '' ? Number(formData.seq) : 50,
                        content: formData.content || ''
                    };
                    
                    const promise = submitData.id > 0 
                        ? helpPageUpdate(submitData) 
                        : helpPageAdd(submitData);
                    
                    promise.then(res => {
                        if (res && res.isSucceed !== false) {
                            const message = submitData.id > 0 ? '修改帮助中心成功' : '新增帮助中心成功';
                            this.helpPageFormAfter(message);
                        } else {
                            this.$message.error(res?.message || '操作失败');
                            this.helpPageFormModalLoading = false;
                        }
                    }).catch(error => {
                        console.error('操作失败:', error);
                        this.$message.error(error?.message || '操作失败，请稍后重试');
                        this.helpPageFormModalLoading = false;
                    });
                } else {
                    return false;
                }
            });
        },
        helpPageFormModalCancel() {
            this.helpPageFormModalVisible = false;
        },
        helpPageFormAfter(message) {
            this.helpPageFormModalVisible = false;
            this.helpPageFormModalLoading = false;
            this.fetchTableData();
            this.$message.success(message);
        },
        onCreateTime(values) {
            if (values && values.length === 2) {
                this.queryParams.startCreateTime = moment(values[0]).unix();
                this.queryParams.endCreateTime = moment(values[1]).unix();
            } else {
                delete this.queryParams.startCreateTime;
                delete this.queryParams.endCreateTime;
            }
        },
        deleteRecord(record) {
            if (!record.id) {
                this.$message.error('删除失败：记录ID不存在');
                return;
            }
            
            helpPageDelete(record.id).then(res => {
                if (res && res.isSucceed !== false) {
                    this.$message.success('删除成功');
                    this.fetchTableData();
                } else {
                    this.$message.error(res?.message || '删除失败');
                }
            }).catch(error => {
                console.error('删除失败:', error);
                this.$message.error(error?.message || '删除失败，请稍后重试');
            });
        }
    }
}
</script>

<style scoped>

</style>

